import axios from 'axios'
import { uniqueId } from 'lodash'
import Vapi from 'vuex-rest-api'

const api = new Vapi({
  axios,
  state: {
    polls: [],
    isAnonymous: false,
  },
})
  .get({
    action: 'getPolls',
    property: 'polls',
    path: '/polls',
    onSuccess(state, payload, axios, { params, data }) {
      let res = []

      if (payload.data) {
        res = Object.keys(payload.data).map((key) => {
          const obj = payload.data[key]
          return {
            ...obj,
            title: key,
            questionsCount: obj.items.length,
          }
        })
      }

      state.polls = res
    },
  })
  .post({
    action: 'votePoll',
    // property: 'poll',
    path: ({ id }) => `/polls/${id}/vote`,
    onSuccess(state, payload, axios, { params, data }) {
      const { id, status, votes, voted, votes_count } = payload.data

      state.polls = [
        ...state.polls.map((x) => {
          return {
            ...x,
            items: x.items.map((p) =>
              p.id !== id
                ? p
                : {
                    ...p,
                    ...{
                      status,
                      votes,
                      voted,
                      votes_count,
                    },
                  }
            ),
          }
        }),
      ]
    },
  })
  .post({
    action: 'cancelPoll',
    // property: 'polls',
    path: ({ id }) => `/polls/${id}/cancel`,
    onSuccess(state, payload, axios, { params, data }) {
      const { id, status, votes, voted, votes_count } = payload.data

      state.polls = [
        ...state.polls.map((x) => {
          return {
            ...x,
            items: x.items.map((p) =>
              p.id !== id
                ? p
                : {
                    ...p,
                    ...{
                      status,
                      votes,
                      voted,
                      votes_count,
                      canceled: true,
                    },
                  }
            ),
          }
        }),
      ]
    },
  })
  .get({
    action: 'getPollResults',
    property: 'pollResults',
    path: ({ id }) => `/polls/${id}/results`,
  })
  .getStore({ namespaced: true })

export default {
  ...api,
  mutations: {
    setAnonymos(state, v) {
      state.isAnonymous = v
    },
    ...api.mutations,
  },
  getters: {
    pollsList(s) {
      return s.polls
    },
    pollItems(s) {
      let res = []
      if (s.polls && s.polls.length) {
        s.polls.forEach((x) => {
          if (x.items && x.items.length) {
            x.items.forEach((poll) => {
              res.push(poll)
            })
          }
        })
      }

      return res
    },
    pollById: (s, getters) => (id) => {
      const polls = getters.pollsList || []

      if (polls && polls.length) {
        return polls.find((x) => parseInt(x.id) === parseInt(id))
      }

      return null
    },
    pollGroupByIdPoll: (s, getters) => (id) => {
      return s.polls.find((group) => {
        return group.items.some((poll) => poll.id === id)
      })
    },
    getStatus:
      (s, getters) =>
      ({ poll, user_id, r_type = 'detail' }) => {
        if (r_type === 'detail') {
          if (poll.canceled) {
            return 4
          }
          if (poll.voted) {
            return 3
          } else {
            return 1
          }
        } else {
          return poll.status.id
        }
      },
    getNextPoll: (s, getters) => (cur_id) => {
      const id = +cur_id
      const currGroup = getters.pollGroupByIdPoll(id)
      console.log(currGroup)
      if (currGroup) {
        const nextPoll = currGroup.items.find((poll) => !poll.voted && !poll.canceled)
        console.log(nextPoll)
        return nextPoll
      }
    },
    isAnonymous(s) {
      return s.isAnonymous
    },
  },
}
